import { AnyAction } from 'redux';

import { RequestStatus } from 'common/enums/request-status';
import { Account } from '../common/interfaces/account';
import { accountReducerMethods } from '../units/account/reducer-methods';
import { subscriptionReducerMethods } from '../units/subscription/reducers/reducer';

export const ACCOUNT_INITIAL_STATE: Account = {
  selectedSubscriptionType: null,
  status: { hasError: false, message: '' },
  restrictAvatarFile: null,
  companies: null,
  selectedCompany: null,
  subscribeMotivationDialogOpenTime: null,
  subscriptionRoles: {
    roles: null,
  },
  updateRolesPermissionStatus: RequestStatus.NotRequested,
  updateRolesStatus: RequestStatus.NotRequested,
  statuses: {
    fetchCompanies: RequestStatus.Loaded,
    createCompany: RequestStatus.Loaded,
  },
  settings: {
    isImperial: false,
  },

  initialAppDataStatus: RequestStatus.NotRequested,
  subscriptionPlans: null,
  ownCompanyBillingInfo: null,
  requests: {
    subscriptionPlans: RequestStatus.NotRequested,
    ownCompanyBillingInfo: RequestStatus.NotRequested,
  },
  motivationPopupSettings: null,
  billingCountries: [],
  payment: null,
  paymentStatus: RequestStatus.NotRequested,
  billingEstimation: null,
  billingEstimationError: null,
  subscriptionValidation: {
    vatNumberValidation: '',
    renewValidation: '',
  },
};

export default function account(
  state: Account = ACCOUNT_INITIAL_STATE,
  action: AnyAction = { type: '', payload: null },
): Account {
  if (action.type in accountReducerMethods) {
    return accountReducerMethods[action.type](state, action.payload);
  } else if (action.type in subscriptionReducerMethods) {
    return subscriptionReducerMethods[action.type](state, action.payload);
  }
  return state;
}
